<template>
  <div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <onaydialog ref="onaydialog"></onaydialog>
    <satisiadefatura
      ref="satisiadefatura"
      @changeSatisFat="changeSatisFatura($event)"
    ></satisiadefatura>

    <v-form ref="formgelenfatura" v-model="validform" lazy-validation>
      <v-card flat color="grey lighten-5">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title> {{ sayfabaslik }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-tooltip v-if="kaydetbuton" bottom>
                <v-btn
                  :disabled="!sayfayetki.Save"
                  slot="activator"
                  @click="Kaydet('1')"
                  flat
                >
                  <span class="hidden-sm-and-down">
                    {{ $t("save_button") }}
                  </span>
                  <v-icon right dark>add_box</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Save">{{ $t("save_button") }}</span>
              </v-tooltip>

              <v-tooltip v-if="guncellebuton" bottom>
                <v-btn
                  v-if="guncellebuton"
                  :disabled="!sayfayetki.Update"
                  slot="activator"
                  @click="Kaydet('2')"
                  flat
                >
                  <span class="hidden-sm-and-down"> {{ $t('Update') }} </span>
                  <v-icon color="white" right dark>create</v-icon>
                </v-btn>
                <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
              </v-tooltip>

              <v-menu bottom left>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-tooltip bottom>
                    <v-list-tile
                      v-if="guncellebuton"
                      slot="activator"
                      :disabled="!sayfayetki.Delete"
                      @click="faturasil()"
                    >
                      <v-list-tile-title> {{ $t('Delete-Invoice') }} </v-list-tile-title>
                    </v-list-tile>
                    <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                    <span v-if="sayfayetki.Delete"> {{ $t('Delete-Invoice') }} </span>
                  </v-tooltip>

                  <a target="_self" v-bind:href="'#/fatura/copersatisiade'">
                    <v-list-tile>
                      <v-list-tile-title
                        >{{ $t("List-of-Invoices-Received") }}
                      </v-list-tile-title>
                    </v-list-tile>
                  </a>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-layout row wrap>
              <v-flex pa-1 xs12 sm12 md4>
                <v-flex mt-2 xs12 sm12 md12>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            
                              
                              
                                <caricomp
                                  v-bind:zorunlumu="false"
                                  v-model="GelenFatura.Fatura.CariInfo.kod"
                                  v-bind:aktifmi="true"
                                  v-bind:Coper="true"

                                ></caricomp>
                                
                              
                            
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-flex>

              <v-flex pa-1 mt-2 xs12 sm6 md4>
                <v-card flat class="white--text">
                  <v-card flat="">
                    <v-card-actions>
                      <v-layout row wrap>
                        <v-layout row wrap>
                          <v-flex xs12 sm6 md6>
                            <v-autocomplete
                              :items="doviztipi"
                              hide-details=""
                              item-text="Title"
                              item-value="DovizKod"
                              v-model="GelenFatura.Fatura.FatPara"
                              @change="kurgetir2()"
                              :label="$t('Invoice-Money')"
                            >
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs12 sm6 md6>
                            <dovizinput
                              v-model="GelenFatura.Fatura.FatKur"
                              :etiket="$t('Invoice-Exchange-Rate')"
                              :autocomplete="autocomplete"
                            >
                            </dovizinput>
                          </v-flex>

                          <v-flex pt-2 xs12 sm12 md12>
                            <v-btn
                              outline
                              @click.native="ekstradialog = true"
                              block
                              color="info"
                            >
                              {{ $t('Extra-Details') }} 
                            </v-btn>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>

              <v-flex pa-1 xs12 mt-2 sm6 md4>
                <v-flex xs12 sm12 md12>
                  <v-card flat class="white--text">
                    <v-card flat="">
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-layout row wrap>
                            <v-flex xs12 sm6 md6>
                              <tarihcomp
                                :etiket="$t('Invoice-Date')"
                                :detaygizle="true"
                                :rules="[(v) => !!v || $t('Please-select-a-date')]"
                                v-bind:defaultvalue="'ok'"
                                v-bind:value="GelenFatura.Fatura.FatTarih"
                                v-model="GelenFatura.Fatura.FatTarih"
                              >
                              </tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm6 md6>
                              <tarihcomp
                                :etiket="this.$t('Maturity')"
                                :detaygizle="true"
                                :rules="[(v) => !!v || $t('Please-select-a-date')]"
                                v-bind:defaultvalue="'ok'"
                                v-bind:value="GelenFatura.Fatura.VadeTarihi"
                                v-model="GelenFatura.Fatura.VadeTarihi"
                              >
                              </tarihcomp>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm6 md6>
                                  <v-text-field
                                    :disabled="seridisable"
                                    :label="$t('Invoice-Serial-No-v2')"
                                    hide-details
                                    :rules="[
                                      (v) => !!v || $t('Mandatory-Areas'),
                                      () =>
                                        (!!GelenFatura.Fatura.FatSeri &&
                                          GelenFatura.Fatura.FatSeri.length <=
                                            3) ||
                                        $t('Cannot-exceed-three-characters'),
                                    ]"
                                    v-model="GelenFatura.Fatura.FatSeri"
                                  ></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm6 md6>
                                  <v-text-field
                                    hide-details=""
                                    mask="#########"
                                    :disabled="seridisable"
                                    :label="$t('Invoice-No')"
                                    v-model="GelenFatura.Fatura.FatNo"
                                    :rules="[(v) => !!v || $t('Mandatory-Areas')]"
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs6 sm6 md6>
                              <v-text-field
                                label="Satış Fat Seri"
                                disabled
                                v-model="
                                  GelenFatura.Fatura.SatisFaturasi.FatSeri
                                "
                              >
                              </v-text-field>
                            </v-flex>
                            
                            <v-flex xs6 sm6 md6>
                              <v-layout>
                              <v-text-field
                                label="Satış Fat No"
                                disabled
                                v-model="GelenFatura.Fatura.SatisFaturasi.FatNo"
                              >
                               
                              </v-text-field>
                              </v-layout>
                            </v-flex>
                                 
                            <v-flex xs12 sm12 md12 pr-3>
                              <v-layout>
                                <v-btn  @click="openSatisFatDialog" color="info" block>{{$t('Please-select-sales-invoice')}}</v-btn>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-flex>
            </v-layout>

            <v-flex mt-2 xs12 sm12 md12>
              <v-card color="grey lighten-5" flat="">
                <v-card-actions>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 md12>
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap class="project overdue">
                            <v-toolbar flat="" size="120px" dark color="white">
                              <v-toolbar-title>
                                <span class="subheading black--text">
                                   {{ $t('Sales-Items') }} 
                                </span>
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <v-btn color="grey" @click="satirekle()" flat
                                > {{ $t('Add-Item') }} 
                                <v-icon color="grey" right dark>add_box</v-icon>
                              </v-btn>
                            </v-toolbar>
                          </v-layout>
                        </v-flex>
                        <v-flex
                          pl-2
                          v-if="GelenFatura.Fatura.Kalemler.length == 0"
                          xs12
                          sm12
                          md12
                        >
                          <span class="grey--text"> {{ $t('Item-has-yet-to-be-added') }} </span>
                        </v-flex>

                        <v-flex
                          v-for="item in GelenFatura.Fatura.Kalemler"
                          pt-1
                          v-bind:key="item.id"
                          xs12
                          sm12
                          md12
                        >
                          <v-layout class="project overdue">
                            <v-hover>
                              <v-card
                                flat=""
                                slot-scope="{ hover }"
                                :class="`elevation-${hover ? 12 : 2}`"
                                width="100%"
                              >
                                <v-list two-line="">
                                  <v-layout row wrap>
                                    <v-flex xs12 sm12 md12>
                                      <v-card flat class="black--text">
                                        <v-card flat="">
                                          <v-card-actions>
                                            <v-layout row wrap>
                                              <v-flex xs12 sm4 md2>
                                                <v-layout
                                                  v-show="
                                                    $vuetify.breakpoint.md ||
                                                    $vuetify.breakpoint.sm ||
                                                    $vuetify.breakpoint.lg ||
                                                    $vuetify.breakpoint.xl
                                                  "
                                                  align-center
                                                  justify-start
                                                  fill-height
                                                >
                                                  <v-card flat="">
                                                    <v-list-tile>
                                                      <v-list-tile-content>
                                                        <v-layout
                                                          row
                                                          align-center
                                                          justify-start
                                                        >
                                                          <v-chip
                                                            small=""
                                                            color="pink"
                                                            text-color="white"
                                                          >
                                                            <v-avatar>
                                                              <v-icon
                                                                color="white"
                                                                >hotel</v-icon
                                                              >
                                                            </v-avatar>
                                                            Coper
                                                          </v-chip>
                                                        </v-layout>

                                                        <v-list-tile-sub-title>
                                                          <div
                                                            class="
                                                              font-weight-bold
                                                            "
                                                          >
                                                            Pnr No:
                                                            {{ item.PNR_No }}
                                                          </div>
                                                        </v-list-tile-sub-title>

                                                        <v-list-tile-sub-title>
                                                          <div
                                                            class="
                                                              font-weight-bold
                                                            "
                                                          >
                                                             {{ $t('Process-Ref') }} :
                                                            {{ item.IslemRef }}
                                                          </div>
                                                        </v-list-tile-sub-title>
                                                      </v-list-tile-content>
                                                    </v-list-tile>
                                                  </v-card>
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs6 sm2 md2>
                                                <v-layout>
                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout
                                                      align-start=""
                                                      justify-start
                                                      fill-height
                                                    >
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content
                                                            style="'overflow=inherit';"
                                                          >
                                                            <v-list-tile-sub-title>
                                                              <div
                                                                class="
                                                                  font-weight-bold
                                                                  caption
                                                                "
                                                              >
                                                                Tutar
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <div
                                                                class="
                                                                  font-weight-bold
                                                                  caption
                                                                "
                                                              >
                                                                {{ $t('VAT-Amount') }} :
                                                              </div>
                                                            </v-list-tile-sub-title>
                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>

                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout
                                                      row
                                                      justify-end=""
                                                      fill-height
                                                    >
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content>
                                                            <v-list-tile-sub-title>
                                                              <v-layout
                                                                align-center=""
                                                                justify-end
                                                              >
                                                                <div
                                                                  class="
                                                                    font-weight-
                                                                    caption
                                                                  "
                                                                >
                                                                  {{
                                                                    item.Tutar
                                                                      | moneyformat
                                                                  }}{{
                                                                    getparabirimiDefault(
                                                                      GelenFatura
                                                                        .Fatura
                                                                        .FatPara
                                                                    )
                                                                  }}
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <v-layout
                                                                align-center=""
                                                                justify-end
                                                              >
                                                                <div
                                                                  class="
                                                                    font-weight-
                                                                    caption
                                                                  "
                                                                >
                                                                  {{
                                                                    item.KDVTutar
                                                                      | moneyformat
                                                                  }}{{
                                                                    getparabirimiDefault(
                                                                      GelenFatura
                                                                        .Fatura
                                                                        .FatPara
                                                                    )
                                                                  }}
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>
                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs6 sm2 md2>
                                                <v-layout>
                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout
                                                      align-start=""
                                                      justify-start
                                                      fill-height
                                                    >
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content
                                                            style="'overflow=inherit';"
                                                          >
                                                            <v-list-tile-sub-title>
                                                              <div
                                                                class="
                                                                  font-weight-bold
                                                                  caption
                                                                "
                                                              >
                                                                 {{ $t('Deduction-Rate') }} :
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <div
                                                                class="
                                                                  font-weight-bold
                                                                  caption
                                                                "
                                                              >
                                                                  {{  $t('Deduction-Amount') }}
                                                              </div>
                                                            </v-list-tile-sub-title>
                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>

                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout
                                                      row
                                                      justify-end=""
                                                      fill-height
                                                    >
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content>
                                                            <v-list-tile-sub-title>
                                                              <v-layout
                                                                align-center=""
                                                                justify-end
                                                              >
                                                                <div
                                                                  class="
                                                                    font-weight-
                                                                    caption
                                                                  "
                                                                >
                                                                  {{
                                                                    item.TevkifatOran
                                                                      | orangoster
                                                                  }}%
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <v-layout
                                                                align-center=""
                                                                justify-end=""
                                                              >
                                                                <div
                                                                  class="
                                                                    font-weight-
                                                                    caption
                                                                  "
                                                                >
                                                                  {{
                                                                    item.TevkifatTutar
                                                                      | moneyformat
                                                                  }}{{
                                                                    getparabirimiDefault(
                                                                      GelenFatura
                                                                        .Fatura
                                                                        .FatPara
                                                                    )
                                                                  }}
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>
                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs6 sm2 md2>
                                                <v-layout>
                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout
                                                      align-start=""
                                                      justify-start
                                                      fill-height
                                                    >
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content
                                                            style="'overflow=inherit';"
                                                          >
                                                            <v-list-tile-sub-title>
                                                              <div
                                                                class="
                                                                  font-weight-bold
                                                                  caption
                                                                "
                                                              >
                                                                 {{ $t('Withholding-Rate') }} :
                                                              </div>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <div
                                                                class="
                                                                  font-weight-bold
                                                                  caption
                                                                "
                                                              >
                                                                 {{ $t('Withholding-Amount') }} 
                                                              </div>
                                                            </v-list-tile-sub-title>
                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>

                                                  <v-flex xs12 sm6 md6>
                                                    <v-layout
                                                      row
                                                      justify-end=""
                                                      fill-height
                                                    >
                                                      <v-card flat="">
                                                        <v-list-tile>
                                                          <v-list-tile-content>
                                                            <v-list-tile-sub-title>
                                                              <v-layout
                                                                align-center=""
                                                                justify-end
                                                              >
                                                                <div
                                                                  class="
                                                                    font-weight-
                                                                    caption
                                                                  "
                                                                >
                                                                  {{
                                                                    item.StopajOran
                                                                      | moneyformat
                                                                  }}%
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>

                                                            <v-list-tile-sub-title>
                                                              <v-layout
                                                                align-center=""
                                                                justify-end=""
                                                              >
                                                                <div
                                                                  class="
                                                                    font-weight-
                                                                    caption
                                                                  "
                                                                >
                                                                  {{
                                                                    item.StopajTutar
                                                                      | moneyformat
                                                                  }}{{
                                                                    getparabirimiDefault(
                                                                      GelenFatura
                                                                        .Fatura
                                                                        .FatPara
                                                                    )
                                                                  }}
                                                                </div>
                                                              </v-layout>
                                                            </v-list-tile-sub-title>
                                                          </v-list-tile-content>
                                                        </v-list-tile>
                                                      </v-card>
                                                    </v-layout>
                                                  </v-flex>
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs12 sm4 md2>
                                                <v-layout
                                                  row
                                                  align-center
                                                  justify-center=""
                                                  fill-height=""
                                                >
                                                  <v-card flat="">
                                                    <v-list-tile>
                                                      <v-list-tile-content>
                                                        <v-layout
                                                          row
                                                          wrap
                                                          justify-center=""
                                                        >
                                                          <v-list-tile-title>
                                                            <v-layout
                                                              row
                                                              wrap
                                                              justify-center=""
                                                            >
                                                              KDV'li Tutar
                                                            </v-layout>
                                                          </v-list-tile-title>
                                                          <v-list-tile-sub-title>
                                                            <v-layout
                                                              row
                                                              wrap
                                                              justify-end=""
                                                            >
                                                              <div
                                                                class="
                                                                  red--text
                                                                  subheading
                                                                "
                                                              >
                                                                {{
                                                                  item.KDVliTutar
                                                                    | moneyformat
                                                                }}{{
                                                                  getparabirimiDefault(
                                                                    GelenFatura
                                                                      .Fatura
                                                                      .FatPara
                                                                  )
                                                                }}
                                                              </div>
                                                            </v-layout>
                                                          </v-list-tile-sub-title>
                                                          <v-list-tile-title>
                                                            <v-layout
                                                              row
                                                              wrap
                                                              justify-center=""
                                                            >
                                                              <div
                                                                class="
                                                                  font-weight
                                                                  green--text
                                                                  caption
                                                                "
                                                              >
                                                                %
                                                                {{
                                                                  item.KDVYuzde
                                                                    | moneyformat
                                                                }}
                                                                {{ $t('VAT') }}
                                                              </div>
                                                            </v-layout>
                                                          </v-list-tile-title>
                                                        </v-layout>
                                                      </v-list-tile-content>
                                                    </v-list-tile>
                                                  </v-card>
                                                </v-layout>
                                              </v-flex>

                                              <v-flex xs12 sm4 md2>
                                                <v-card flat="">
                                                  <v-layout
                                                    row
                                                    wrap
                                                    align-center=""
                                                    justify-end=""
                                                    fill-height=""
                                                  >
                                                    <v-flex xs2 sm2 md2>
                                                      <v-tooltip
                                                        slot="append"
                                                        bottom
                                                      >
                                                        <v-btn
                                                          slot="activator"
                                                          icon
                                                          class="mx-0"
                                                          @click="
                                                            satirsil(item)
                                                          "
                                                        >
                                                          <v-icon color="red"
                                                            >delete</v-icon
                                                          >
                                                        </v-btn>
                                                        <span> {{ $t('Delete') }} </span>
                                                      </v-tooltip>
                                                    </v-flex>

                                                    <!-- <v-flex xs2 sm2 md2>
                                                      <v-tooltip slot="append" bottom>
                                                        <v-btn slot="activator" icon class="mx-0"
                                                          @click="satirduzenle(item)">
                                                          <v-icon color="green">edit</v-icon>
                                                        </v-btn>
                                                        <span>Düzenle</span>
                                                      </v-tooltip>
                                                    </v-flex> -->
                                                  </v-layout>
                                                </v-card>
                                              </v-flex>
                                            </v-layout>
                                          </v-card-actions>
                                        </v-card>
                                      </v-card>
                                    </v-flex>
                                  </v-layout>
                                </v-list>
                              </v-card>
                            </v-hover>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-container>

          <v-container fluid>
            <v-layout>
              <v-flex xs12 sm12 md12>
                <v-layout justify-end="" row>
                  <v-flex xs12 sm12 md4>
                    <v-card flat class="white--text">
                      <v-layout class="project overdue">
                        <v-flex xs2 sm2 md2>
                          <v-layout
                            align-center=""
                            justify-center=""
                            fill-height=""
                          >
                            <v-icon color="info" large="">queue</v-icon>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm10 md10>
                          <v-card-title primary-title="">
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span
                                      class="subheading grey--text font-weight-"
                                    >
                                      Matrah
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-list-tile-title>
                                    <span
                                      class="subheading grey--text font-weight-"
                                    >
                                      :
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>

                                <v-flex xs7 sm7 md7>
                                  <v-list-tile-title>
                                    <v-layout justify-end>
                                      <span
                                        class="
                                          subheading
                                          grey--text
                                          font-weight-
                                        "
                                      >
                                        {{
                                          GelenFatura.Fatura.ToplamTutar
                                            | moneyformat
                                        }}{{
                                          getparabirimiDefault(
                                            GelenFatura.Fatura.FatPara
                                          )
                                        }}
                                      </span>
                                    </v-layout>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span
                                      class="subheading grey--text font-weight-"
                                    >
                                       {{ $t('Total-VAT') }} 
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-list-tile-title>
                                    <span
                                      class="subheading grey--text font-weight-"
                                    >
                                      :
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs7 sm7 md7>
                                  <v-list-tile-title>
                                    <v-layout justify-end>
                                      <span
                                        class="
                                          subheading
                                          grey--text
                                          font-weight-
                                        "
                                      >
                                        {{
                                          GelenFatura.Fatura.ToplamKDVTutar
                                            | moneyformat
                                        }}{{
                                          getparabirimiDefault(
                                            GelenFatura.Fatura.FatPara
                                          )
                                        }}
                                      </span>
                                    </v-layout>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span
                                      class="subheading grey--text font-weight-"
                                    >
                                        {{  $t('Deduction-Amount') }}
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-list-tile-title>
                                    <span
                                      class="subheading grey--text font-weight-"
                                    >
                                      :
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs7 sm7 md7>
                                  <v-list-tile-title>
                                    <v-layout justify-end>
                                      <span
                                        class="
                                          subheading
                                          grey--text
                                          font-weight-
                                        "
                                      >
                                        {{
                                          GelenFatura.Fatura.ToplamTevkifatTutar
                                            | moneyformat
                                        }}{{
                                          getparabirimiDefault(
                                            GelenFatura.Fatura.FatPara
                                          )
                                        }}
                                      </span>
                                    </v-layout>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-divider></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout>
                                <v-flex xs12 sm4 md4>
                                  <v-list-tile-title>
                                    <span
                                      class="subheading grey--text font-weight-"
                                    >
                                        {{ $t('Invoice-Amount') }}
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs1 sm1 md1>
                                  <v-list-tile-title>
                                    <span
                                      class="subheading grey--text font-weight-"
                                    >
                                      :
                                    </span>
                                  </v-list-tile-title>
                                </v-flex>
                                <v-flex xs7 sm7 md7>
                                  <v-list-tile-title>
                                    <v-layout justify-end>
                                      <span
                                        class="
                                          subheading
                                          grey--text
                                          font-weight-
                                        "
                                      >
                                        {{
                                          GelenFatura.Fatura.FaturaNetTutar
                                            | moneyformat
                                        }}{{
                                          getparabirimiDefault(
                                            GelenFatura.Fatura.FatPara
                                          )
                                        }}
                                      </span>
                                    </v-layout>
                                  </v-list-tile-title>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-card-title>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-container>
        </v-layout>
      </v-card>
    </v-form>

    <v-dialog v-model="ekstradialog" scrollable="" persistent max-width="350px">
      <v-card>
        <v-card-title> {{ $t('Extra-Details') }}  </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <v-flex pb-3 xs12 sm12 md12>
              <geneltipara
                tip="CariTransferKod"
                v-model="GelenFatura.Fatura.TransferKod"
              ></geneltipara>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="ekstradialog = false"
            >{{ $t('OK') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="satirdialog"
      scrollable=""
      persistent=""
      max-width="850px"
    >
      <v-card color="grey lighten-5">
        <v-card-title> {{$t('Line-Entry')}} </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <v-flex v-if="!kalemkayitvarmi" xs12 sm12 md12>
              <v-alert type="error" value="true">
                <span> Kayıt bulunamadı</span>
              </v-alert>
            </v-flex>

            <v-flex xs12 sm12 v-if="itemsgelen.length != -10" md12>
              <v-card flat class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <!-- <v-flex xs12 sm6 md6>
                        <parainputevents :aktif="true" :simge="getparabirimi()" @odakkaybi="kdvlitutarblur"
                          v-model="SatirGelenFatura.KDVliTutar" :etiket="'KDVli Tutar'" :autocomplete="autocomplete">
                        </parainputevents>
                      </v-flex> -->

                      <v-flex xs12 sm6 md6>
                        <yuzdeinput
                          v-model="SatirGelenFatura.KDVYuzde"
                          :etiket="$t('VAT') + ' %'"
                        ></yuzdeinput>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <div></div>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents
                          :simge="
                            getparabirimiDefault(GelenFatura.Fatura.FatPara)
                          "
                          @odakkaybi="tutarblur"
                          v-model="SatirGelenFatura.Tutar"
                          :etiket="$t('Amount-without-VAT')"
                          :autocomplete="autocomplete"
                        >
                        </parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <parainputevents
                          :simge="
                            getparabirimiDefault(GelenFatura.Fatura.FatPara)
                          "
                          @odakkaybi="kdvtutarblur"
                          v-model="SatirGelenFatura.KDVTutar"
                          :etiket="$t('VAT-Amount')"
                          :autocomplete="autocomplete"
                        >
                        </parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <v-select
                          :items="Tevkifat"
                          hide-details=""
                          item-text="text"
                          item-value="value"
                          v-model="SatirGelenFatura.TevkifatOran"
                          @change="Tevkifatkdvhesapla()"
                          :label="$t('Deduction-Rate')"
                        ></v-select>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <parainputevents
                          :simge="
                            getparabirimiDefault(GelenFatura.Fatura.FatPara)
                          "
                          v-model="SatirGelenFatura.TevkifatTutar"
                          :etiket="$t('Deduction-Amount')"
                          :autocomplete="autocomplete"
                        ></parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <yuzdeinput
                          v-model="SatirGelenFatura.StopajOran"
                          :etiket="'Stopaj Oranı'"
                        ></yuzdeinput>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents
                          :simge="
                            getparabirimiDefault(GelenFatura.Fatura.FatPara)
                          "
                          @odakkaybi="stopajtutarblur"
                          v-model="SatirGelenFatura.StopajTutar"
                          :etiket="$t('Withholding-Amount')"
                          :autocomplete="autocomplete"
                        >
                        </parainputevents>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <v-flex xs12 v-if="itemsgelen.length != -10" pt-2 sm12 md12>
              <v-layout row wrap>
                <v-flex xs12 sm12 md12>
                  <v-layout row wrap class="project overdue">
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title>
                        <span class="subheading black--text"> {{ $t('Items') }} </span>
                      </v-toolbar-title>
                      <v-spacer></v-spacer>
                    </v-toolbar>
                  </v-layout>
                </v-flex>

                <v-flex
                  v-for="item in itemsgelen"
                  pt-1
                  v-bind:key="item.id"
                  xs12
                  sm12
                  md12
                >
                  <v-hover>
                    <v-card
                      flat=""
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 12 : 2}`"
                      width="100%"
                    >
                      <v-list three-line="">
                        <v-layout row wrap>
                          <v-flex xs1 sm1 md1> &nbsp; </v-flex>
                          <v-flex pl-4 xs11 sm11 md11>
                            <v-chip
                              v-if="item.SaticiTip == 1"
                              small=""
                              color="pink"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">hotel</v-icon>
                              </v-avatar>
                              Hotel
                            </v-chip>
                            <v-chip
                              small=""
                              v-if="item.SaticiTip == 1"
                              color="white"
                              text-color="green"
                            >
                              <v-avatar>
                                <v-icon color="green"
                                  >check_circle_outline</v-icon
                                >
                              </v-avatar>
                               {{ $t('Relevant-Seller') }} 
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 2"
                              small=""
                              color="orange"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">rv_hookup</v-icon>
                              </v-avatar>
                              Transfer
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 3"
                              small=""
                              color="deep-purple"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">restaurant</v-icon>
                              </v-avatar>
                              Restaurant
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 4"
                              small=""
                              color="yellow accent-4"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">local_see</v-icon>
                              </v-avatar>
                              {{ $t('Tour') }}
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 5"
                              small=""
                              color="green"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">departure_board</v-icon>
                              </v-avatar>
                              Rentacar
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 6"
                              small=""
                              color="teal accent-4"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">emoji_people</v-icon>
                              </v-avatar>
                              {{ $t("Guide") }}
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 7"
                              small=""
                              color="orange"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">museum</v-icon>
                              </v-avatar>
                              {{ $t("Museum") }}
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 8"
                              small=""
                              color="blue darken-4"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">flight_takeoff</v-icon>
                              </v-avatar>
                              {{ $t("Airline") }}
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 9"
                              small=""
                              color="cyan darken-2"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">directions_boat</v-icon>
                              </v-avatar>
                              {{ $t("Cruise") }}
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 10"
                              small=""
                              color="pink"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">category</v-icon>
                              </v-avatar>
                              {{ $t("Other") }}
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 11"
                              small=""
                              color="brown"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">style</v-icon>
                              </v-avatar>
                              {{ $t("Visa") }}
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 12"
                              small=""
                              color="deep-purple"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">style</v-icon>
                              </v-avatar>
                              {{ $t("Tour-Operator") }}
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 13"
                              small=""
                              color="info"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">style</v-icon>
                              </v-avatar>
                              Konsolosluk
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 14"
                              small=""
                              color="lime"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">verified_user</v-icon>
                              </v-avatar>
                              {{ $t("Insurance") }}
                            </v-chip>

                            <v-chip
                              v-if="item.SaticiTip == 15"
                              small=""
                              color="blue"
                              text-color="white"
                            >
                              <v-avatar>
                                <v-icon color="white">directions_boat</v-icon>
                              </v-avatar>
                              {{ $t("Ferry") }}
                            </v-chip>

                            <span class="font-weight-bold grey--text body-1">
                              {{ $t("Seller") }}:
                            </span>
                            {{ item.SaticiKod }}-{{ item.SaticiAd }} -
                            <span class="font-weight-bold grey--text body-1"
                              > {{ $t('Operator-Code') }} : </span
                            >{{ item.TurOperatoru }}
                          </v-flex>
                        </v-layout>

                        <v-layout row wrap>
                          <v-flex xs12 sm12 md12>
                            <v-card flat class="black--text">
                              <v-card flat="">
                                <v-card-actions>
                                  <v-layout row wrap>
                                    <v-list-tile>
                                      <v-list-tile-content>
                                        <v-layout justify-start="" align-start>
                                          <v-flex xs1 sm1 md1>
                                            <v-checkbox
                                              hide-details=""
                                              v-model="secilenkayitlar"
                                              :value="item"
                                            >
                                            </v-checkbox>
                                          </v-flex>
                                        </v-layout>
                                      </v-list-tile-content>
                                    </v-list-tile>

                                    <v-flex xs12 sm4 md2>
                                      <v-layout
                                        justify-start=""
                                        row
                                        align-center=""
                                      >
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout
                                                justify-start=""
                                                align-center=""
                                              >
                                                <v-flex>
                                                  <v-list-tile-sub-title>
                                                    <v-layout
                                                      justify-start=""
                                                      align-center
                                                    >
                                                      <div
                                                        class="
                                                          font-weight-
                                                          red--text
                                                          subheading
                                                        "
                                                      >
                                                        {{
                                                          item.Donem1
                                                            | dateformat
                                                        }}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout
                                                      justify-start=""
                                                      align-center
                                                    >
                                                      <div
                                                        class="
                                                          font-weight-
                                                          red--text
                                                          subheading
                                                        "
                                                      >
                                                        {{
                                                          item.Donem2
                                                            | dateformat
                                                        }}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-flex>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs6 sm3 md3>
                                      <v-layout>
                                        <v-flex xs12 sm6 md8>
                                          <v-layout
                                            align-start=""
                                            justify-start
                                            fill-height
                                          >
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content
                                                  style="'overflow=inherit';"
                                                >
                                                  <v-list-tile-sub-title>
                                                    <div
                                                      class="
                                                        font-weight-bold
                                                        caption
                                                      "
                                                    >
                                                      Tutar
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <div
                                                      class="
                                                        font-weight-bold
                                                        caption
                                                      "
                                                    >
                                                      {{ $t('VAT') }}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div
                                                      class="
                                                        font-weight-bold
                                                        caption
                                                      "
                                                    >
                                                      {{ $t('VAT-Amount') }} :
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <div
                                                      class="
                                                        font-weight-bold
                                                        caption
                                                      "
                                                    >
                                                      KDV'li Tutar
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm6 md4>
                                          <v-layout
                                            row
                                            justify-end=""
                                            fill-height
                                          >
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-list-tile-sub-title>
                                                    <v-layout
                                                      align-center=""
                                                      justify-end
                                                    >
                                                      <div
                                                        class="
                                                          font-weight-
                                                          caption
                                                        "
                                                      >
                                                        {{
                                                          item.Tutar
                                                            | moneyformat
                                                        }}{{
                                                          getparabirimiDefault(
                                                            GelenFatura.Fatura
                                                              .FatPara
                                                          )
                                                        }}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout
                                                      align-center=""
                                                      justify-end=""
                                                    >
                                                      <div
                                                        class="
                                                          font-weight-
                                                          caption
                                                        "
                                                      >
                                                        {{
                                                          item.KDVYuzde
                                                            | moneyformat
                                                        }}%
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout
                                                      align-center=""
                                                      justify-end
                                                    >
                                                      <div
                                                        class="
                                                          font-weight-
                                                          caption
                                                        "
                                                      >
                                                        {{
                                                          item.KDVTutar
                                                            | moneyformat
                                                        }}{{
                                                          getparabirimiDefault(
                                                            GelenFatura.Fatura
                                                              .FatPara
                                                          )
                                                        }}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout
                                                      align-center=""
                                                      justify-end=""
                                                    >
                                                      <div
                                                        class="
                                                          font-weight-
                                                          caption
                                                        "
                                                      >
                                                        {{
                                                          item.KDVliTutar
                                                            | moneyformat
                                                        }}{{
                                                          getparabirimiDefault(
                                                            GelenFatura.Fatura
                                                              .FatPara
                                                          )
                                                        }}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs6 sm3 md3>
                                      <v-layout>
                                        <v-flex xs12 sm6 md8>
                                          <v-layout
                                            align-start=""
                                            justify-start
                                            fill-height
                                          >
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content
                                                  style="'overflow=inherit';"
                                                >
                                                  <v-list-tile-sub-title>
                                                    <div
                                                      class="
                                                        font-weight-bold
                                                        caption
                                                      "
                                                    >
                                                       {{ $t('Deduction-Rate') }} :
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <div
                                                      class="
                                                        font-weight-bold
                                                        caption
                                                      "
                                                    >
                                                        {{  $t('Deduction-Amount') }}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                  <v-list-tile-sub-title>
                                                    <div
                                                      class="
                                                        font-weight-bold
                                                        caption
                                                      "
                                                    >
                                                      {{ $t('Withholding-Rate') }} :
                                                    </div>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <div
                                                      class="
                                                        font-weight-bold
                                                        caption
                                                      "
                                                    >
                                                      {{ $t('Withholding-Amount') }}
                                                    </div>
                                                  </v-list-tile-sub-title>
                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>

                                        <v-flex xs12 sm6 md4>
                                          <v-layout
                                            row
                                            justify-end=""
                                            fill-height
                                          >
                                            <v-card flat="">
                                              <v-list-tile>
                                                <v-list-tile-content>
                                                  <v-list-tile-sub-title>
                                                    <v-layout
                                                      align-center=""
                                                      justify-end
                                                    >
                                                      <div
                                                        class="
                                                          font-weight-
                                                          caption
                                                        "
                                                      >
                                                        {{
                                                          item.TevkifatOran
                                                            | orangoster
                                                        }}%
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout
                                                      align-center=""
                                                      justify-end=""
                                                    >
                                                      <div
                                                        class="
                                                          font-weight-
                                                          caption
                                                        "
                                                      >
                                                        {{
                                                          item.TevkifatTutar
                                                            | moneyformat
                                                        }}{{
                                                          getparabirimiDefault(
                                                            GelenFatura.Fatura
                                                              .FatPara
                                                          )
                                                        }}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout
                                                      align-center=""
                                                      justify-end
                                                    >
                                                      <div
                                                        class="
                                                          font-weight-
                                                          caption
                                                        "
                                                      >
                                                        {{
                                                          item.StopajOran
                                                            | moneyformat
                                                        }}%
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>

                                                  <v-list-tile-sub-title>
                                                    <v-layout
                                                      align-center=""
                                                      justify-end=""
                                                    >
                                                      <div
                                                        class="
                                                          font-weight-
                                                          caption
                                                        "
                                                      >
                                                        {{
                                                          item.StopajTutar
                                                            | moneyformat
                                                        }}{{
                                                          getparabirimiDefault(
                                                            GelenFatura.Fatura
                                                              .FatPara
                                                          )
                                                        }}
                                                      </div>
                                                    </v-layout>
                                                  </v-list-tile-sub-title>
                                                </v-list-tile-content>
                                              </v-list-tile>
                                            </v-card>
                                          </v-layout>
                                        </v-flex>
                                      </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm4 md2>
                                      <v-layout
                                        row
                                        align-center
                                        justify-center=""
                                        fill-height=""
                                      >
                                        <v-card flat="">
                                          <v-list-tile>
                                            <v-list-tile-content>
                                              <v-layout
                                                row
                                                wrap
                                                justify-center=""
                                              >
                                                <v-list-tile-title>
                                                  <v-layout
                                                    row
                                                    wrap
                                                    justify-center=""
                                                  >
                                                    Satis Fat.Tutar
                                                  </v-layout>
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                  <v-layout
                                                    row
                                                    wrap
                                                    justify-end=""
                                                  >
                                                    <div
                                                      class="
                                                        red--text
                                                        subheading
                                                      "
                                                    >
                                                      {{
                                                        item.KalemMaliyet
                                                          | moneyformat
                                                      }}
                                                      {{
                                                        getparabirimiDefault(
                                                          GelenFatura.Fatura
                                                            .FatPara
                                                        )
                                                      }}
                                                    </div>
                                                  </v-layout>
                                                </v-list-tile-sub-title>
                                                <v-list-tile-title>
                                                  <v-layout
                                                    row
                                                    wrap
                                                    justify-center=""
                                                  >
                                                    <div
                                                      class="
                                                        font-weight
                                                        green--text
                                                        caption
                                                      "
                                                    ></div>
                                                  </v-layout>
                                                </v-list-tile-title>
                                              </v-layout>
                                            </v-list-tile-content>
                                          </v-list-tile>
                                        </v-card>
                                      </v-layout>
                                    </v-flex>
                                  </v-layout>
                                </v-card-actions>
                              </v-card>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-list>
                    </v-card>
                  </v-hover>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="satirdialog = false"
            >{{ $t("cancel_button") }}</v-btn
          >

          <v-btn
            v-if="satirkaydetbuton"
            :disabled="itemsgelen.length == 0"
            color="blue darken-1"
            flat
            @click.native="satirkaydet()"
            >{{ $t('OK') }}</v-btn
          >

          <v-btn
            v-if="satirguncellebuton"
            color="blue darken-1"
            flat
            @click.native="satirguncellekaydet()"
            >{{ $t('Update') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="kalemdialog"
      v-if="kalemdialog"
      scrollable=""
      persistent=""
      max-width="500px"
    >
      <v-card color="grey lighten-5">
        <v-card-title>Kalem Düzenle</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <v-flex xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 md6>
                        <pnrbul
                          v-bind:active="true"
                          v-model="Kalem.PNR_No"
                        ></pnrbul>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents
                          :simge="
                            getparabirimiDefault(GelenFatura.Fatura.FatPara)
                          "
                          v-model="Kalem.Tutar"
                          :etiket="'Tutar'"
                          :autocomplete="autocomplete"
                        >
                        </parainputevents>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <yuzdeinput
                          v-model="Kalem.KDVYuzde"
                          :etiket="$t('VAT')"
                        ></yuzdeinput>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents
                          :simge="
                            getparabirimiDefault(GelenFatura.Fatura.FatPara)
                          "
                          v-model="Kalem.KDVTutar"
                          :etiket="$t('VAT-Amount')"
                          :autocomplete="autocomplete"
                        ></parainputevents>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <v-select
                          :items="Tevkifat"
                          hide-details=""
                          item-text="text"
                          item-value="value"
                          clearable
                          v-model="Kalem.TevkifatOran"
                          @change="Tevkifatkdvhesapla()"
                          :label="$t('Deduction-Rate')"
                        >
                        </v-select>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents
                          :simge="
                            getparabirimiDefault(GelenFatura.Fatura.FatPara)
                          "
                          v-model="Kalem.TevkifatTutar"
                          :etiket="$t('Deduction-Amount')"
                          :autocomplete="autocomplete"
                        ></parainputevents>
                      </v-flex>

                      <v-flex xs12 sm6 md6>
                        <yuzdeinput
                          v-model="Kalem.StopajOran"
                          :etiket="'Stopaj Oranı'"
                        ></yuzdeinput>
                      </v-flex>
                      <v-flex xs12 sm6 md6>
                        <parainputevents
                          :simge="
                            getparabirimiDefault(GelenFatura.Fatura.FatPara)
                          "
                          v-model="Kalem.StopajTutar"
                          :etiket="$t('Withholding-Amount')"
                          :autocomplete="autocomplete"
                        ></parainputevents>
                      </v-flex>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            flat
            @click.native="kalemdialog = false"
            >{{ $t("cancel_button") }}</v-btn
          >
          <v-btn
            color="blue darken-1"
            flat
            @click.native="kalemguncellekaydet()"
            >{{ $t('Update') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="loadingdialog" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
         {{$t('Your-transaction-is-being-processed-Please Wait...')}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogsor" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
        <v-card-text>{{$t('Are-you-sure-you-want-to-delete-this-record')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" flat @click.native="dialogsor = false">{{
            $t("cancel_button")
          }}</v-btn>
          <v-btn v-if="faturasilbtn" color="info" flat @click="faturasil()"
            >{{ $t('OK') }}</v-btn
          >

          <v-btn v-if="satirsilbtn" color="info" flat @click="satirsil()"
            >{{ $t('OK') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <template>
      <v-card>
        <v-snackbar
          :timeout="timeout"
          :top="y === 'top'"
          :bottom="y === 'bottom'"
          :right="x === 'right'"
          :left="x === 'left'"
          :multi-line="mode === 'multi-line'"
          :vertical="mode === 'vertical'"
          v-model="snackbar"
        >
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{
            $t("Close")
          }}</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
import auth from "../../../api/auth";
import parainputevents from "../customcomp/parainputevents";
import dovizinput from "../customcomp/dovizinput";
import yuzdeinput from "../customcomp/yuzdeinput";
import tarihcomp from "../customcomp/tarihim";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue";
import geneltiplist from "@/components/app/customcomp/geneltiplist.vue";
import helpers from "@/components/app/customcomp/helpers.js";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import onaydialog from "@/components/app/customcomp/onaydialog.vue";
import rez from "../coper/rezervasyon";
import genelarama from "@/components/app/coper/comp/genelarama.vue";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import muhasebefistipara from "@/components/app/coper/component/muhasebefistipara.vue";
import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
import tool from "../coper/tools";
import caricomp from "@/components/app/customcomp/caricomp.vue";
import satisiadefatura from "@/components/app/coper/comp/satisiadefatura.vue";

export default {
  props: {
    operation: "",
  },

  data() {
    return {
      kalemkayitvarmi: true,
      pnrkalemloading: false,
      loadingdialog1: true,
      pnretiket: null,
      pnrtip: true,
      islemtipi: 0,
      duzenlenenkayitindex: -1,
      kalemdialog: false,
      secilenkayitlar: [],
      itemsgelen: [],
      blurevents: null,
      itemssaticitip: rez.SaticiTip,

      GelenFatura: {
        KayitTipi: 2,
        Fatura: {
          FatSeri: "",
          FatNo: 0,
          FatTarih: null,
          VadeTarihi: null,
          SatisFaturasi: {
            Id: 0,
            FatSeri: "",
            FatNo: 0,
            FatTarih: null,
          },
          Kalemler: [],
          CariInfo: {
            id: "0",
            kod: "",
            isim: "",
          },
          ToplamStopajTutar: 0.0,
          FatPara: "TL",
          FatKur: 1.0,
          TransferKod: {
            id: "0",
            kod: null,
            isim: null,
            tip: 0,
            intField: null,
          },
          ToplamTutar: 0.0,
          ToplamKDVliTutar: 0.0,
          ToplamKDVTutar: 0.0,
          ToplamTevkifatTutar: 0.0,
          FaturaNetTutar: 0.0,
        },
        EskiFatura: {
          CariKod: "",
          FatSeri: "",
          FatNo: 0,
          FatTarih: null,
        },
      },
      SatirGelenFatura: {
        SaticiTip: 1,
        SaticiKod: "",
        Satici: {},
        StopajOran: 0.0,
        StopajTutar: 0.0,
        KDVYuzde: 0.0,
        Tutar: 0.0,
        KDVliTutar: 0.0,
        KDVTutar: 0.0,
        PNR_No: 0,
        IslemRef: 0,
        TevkifatOran: 0.0,
        TevkifatTutar: 0.0,
        Aciklama: null,
        KdvID: null,
        KdvMuafiyetID: null,
        TevkifatID: null,
      },
      Kalem: {
        SaticiTip: 1,
        SaticiKod: "",
        Satici: {},
        StopajOran: 0.0,
        StopajTutar: 0.0,
        KDVYuzde: 0.0,
        Tutar: 0.0,
        KDVliTutar: 0.0,
        KDVTutar: 0.0,
        PNR_No: 0,
        IslemRef: 0,
        TevkifatOran: 0.0,
        TevkifatTutar: 0.0,
        Aciklama: null,
        KdvID: null,
        KdvMuafiyetID: null,
        TevkifatID: null,
      },
      headerspnr: [
        {
          text: "Satıcı Tip",
          value: "kod",
        },
        {
          text: this.$t("Description"),
          value: "aciklama",
        },
      ],
      kodmesajı: null,
      progress: false,
      items: [],
      aranacakkelime: null,
      secilendeger: null,
      dialog: false,

      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },

      degisenkayit: null,

      silinecekkayit: null,
      dialogsor: false,

      gonderimlabel: null,

      valid: true,

      validform: true,

      autocomplete: "autocomplete",
      drawer: null,
      baslik: "",
      e1: 0,
      Code: "",
      e2: true,
      yok: false,
      statesecili: [
        {
          Kod: "Kod",
          Unvan: "Unvan",
          newProp: "Kod" + " - " + "Unvan",
        },
      ],
      statecari: [],
      secilensatirno: -1,
      search3: "",

      loading: false,
      caritext: "",
      cariid: "",
      aktifdate: false,

      SerbestFatura: {
        SirketKodu: "",
        SerbestFaturaDetay: [],
        Serbest: true,
        AlisSatis: false,
        FaturaSeri: "",
        FaturaNo: "",
        Update: false,
        FaturaTip: 0, // 0 : Satış faturası , 1 : Iade Faturası
        Evrak: {
          Evrakkod: "",
        },
        Cari: {
          Kod: "",
        },

        Tarih: null,
        GibSeri: "",
        Vade: null,
        Referans: {
          Kod: "",
        },
        Masraf: {
          Code: "",
        },
        Aciklama: "",
        Doviz: {
          DovizKod: "",
        },
        Kur: 0,
        TevkivatKdv: 0,
        FaturaID: 0,
        CariAktarma: false,
        Tutarlar: {
          ToplamTutar: 0,
          Iskonto: 0,
          FaturaToplam: 0,
          Kdv: 0,
          TevkifatKdv: 0,
        },
        Efaturakayit: false,
        Earchiveakayit: false,
        Kagitfatura: false,
      },
      SerbestFaturaDetayList: [],

      SerbestFaturaDetay: {
        MuhasebeKodu: "",
        Aciklama: "",
        LineNote: "",
        Referans: {
          Kod: "",
        },
        Masraf: {
          Code: "",
        },
        Miktar: 0,

        BirimFiyat: 0,
        Tutar: 0,
        DovizTutar: 0,
        IskontoYuzde: 0,
        IskontoTutar: 0,
        KdvTip: "D",
        KdvYuzde: 0,
        KdvTutar: 0,
        KdvMuhKodu: "",
        IskMuhKodu: "",
        KdvKodu: "",
        IstisnaKodu: "",
        TevkifatKodu: "",
        Tip: "",
        TevkifatDetayTutar: 0,
        TevkifatDetayOran: 0,
      },

      SerbestFaturaToplamTutarBilgileri: {
        ToplamTutar: 0,
        Iskonto: 0,
        FaturaToplam: 0,
        Kdv: 0,
        TevkifatKdv: 0,
      },

      faturatipi: [
        {
          text: this.$t('Purchase-Expense'),
          value: 0,
        },
        {
          text: this.$t('Sales-Return'),
          value: 1,
        },
        {
          text: this.$t('Advance'),
          value: 2,
        },
        {
          text: this.$t('Self-employed-Receipt'),
          value: 3,
        },
        {
          text: this.$t('Note-of-Expenses'),
          value: 4,
        },
        {
          text: this.$t('Withholding-Donation-Receipt'),
          value: 5,
        },
      ],

      seridisable: false,
      faturagosterbtn: false,
      date: null,
      menu: false,
      modal: false,
      dateFormatted: "",

      datearsiv: null,
      menuarsiv: false,
      modalarsiv: false,
      dateFormattedarsiv: "",
      yedeksatirkayit: {
        Tutar: 0,
        Kdv: 0,
        Tevkifat: 0,
        iskonto: 0,
      },
      date2: null,
      menu2: false,
      dateFormatted2: "",
      modal2: false,
      ihracat: false,
      progress: false,
      satirdialog: false,

      gibseri: [],
      satiritems: [],
      referaslist: [],
      EvrakTipi1: [],
      kdvtipi: [
        {
          text: "D",
          value: "D",
        },
        {
          text: "H",
          value: "H",
        },
      ],
      Tevkifat: [
        {
          text: "0/10",
          value: 0,
        },
        {
          text: "1/10",
          value: 0.1,
        },
        {
          text: "2/10",
          value: 0.2,
        },
        {
          text: "3/10",
          value: 0.3,
        },
        {
          text: "4/10",
          value: 0.4,
        },
        {
          text: "5/10",
          value: 0.5,
        },
        {
          text: "6/10",
          value: 0.6,
        },
        {
          text: "7/10",
          value: 0.7,
        },
        {
          text: "8/10",
          value: 0.8,
        },
        {
          text: "9/10",
          value: 0.9,
        },
        {
          text: "10/10",
          value: 1,
        },
      ],

      doviztipi: [],

      masrafmerkezi: [],
      dictionary: {
        custom: {
          carikod: {
            required: () => this.$t('This-space-cannot-left-blank'),
          },
          unvan: {
            required: () => this.$t('This-space-cannot-left-blank'),
          },
          faturaseri: {
            required: () => this.$t('This-space-cannot-left-blank'),
          },
          faturano: {
            required: () => this.$t('This-space-cannot-left-blank'),
          },

          gtip: {
            min: () => this.$t('Must-least-4-digits'),
          },
        },
      },
      sayfabaslik: "Coper Satış Iade Faturası",
      satirguncellebuton: false,
      satirkaydetbuton: true,
      StartDate: null,
      EndDate: null,
      NumberOfPolicies: "",
      PolicySum: "",
      TotalDebt: "",
      TotalFlatDebt: "",
      kaydetbuton: true,
      guncellebuton: false,
      silbuton: false,
      detaytevkifat: true,
      text1: "",
      denemevalue: 0,

      biletlerfaturalanmasin: null,
      efaturamukellefi: null,
      loadingdialog: false,
      Kdvmuaf: null,
      ciktiistemiyor: null,
      musteribilgitipi: null,
      profilzorunlu: null,
      eventidzorunlu: null,
      snackbar: false,
      y: "top",
      x: "right",
      mode: "",
      timeout: 6000,
      carikod: "",
      unvan: "",
      active: "",
      ex11: "false",

      ekstradialog: false,

      faturasilbtn: false,
      satirsilbtn: false,
      islemturu: null,
      dialogdegistir: false,
      ChangeTarih: null,
      ChangeFaturaNo: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.$validator.localize("en", this.dictionary);
    this.sayfayetki.Status = true;
    this.sayfayetki.Save = true;
    this.sayfayetki.Update = true;
    this.sayfayetki.Delete = true;

    if (this.sayfayetki.Status == true) {
      this.SerbestFaturaDetayList = [];

      var credentials = JSON.parse(window.localStorage.getItem("credentials"));
      var params1 = {
        CompanyCode: credentials.SirketKodu,
      };

      this.$http
        .post(auth.API_URL + "api/currency/List", params1, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.doviztipi = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Döviz Tipi";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Döviz Tipi";
              this.snackbar = true;
            }
          }
        );

      if (this.$route.query.islem == "yeni") {
        this.sayfabaslik = "Coper Satış Iade Faturası";
        this.guncellebuton = false;
        this.kaydetbuton = true;
        this.islemtipi = 1;
      } else if (this.$route.query.islem == "get") {
        this.loadingdialog = true;

        let params = {
          CariKod: this.$route.query.CariKod,
          FatSeri: this.$route.query.FatSeri,
          FatNo: this.$route.query.FatNo,
          FatTarih: this.$route.query.FatTarih,
        };

        tool.http_post(this, "SatisIadeFaturaLoad", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.GelenFatura.Fatura = response.body.data;

              this.GelenFatura.EskiFatura.CariKod = response.body.data.CariInfo.kod;
              this.GelenFatura.EskiFatura.FatSeri = response.body.data.FatSeri;
              this.GelenFatura.EskiFatura.FatNo = response.body.data.FatNo;
              this.GelenFatura.EskiFatura.FatTarih = response.body.data.FatTarih;

              this.GelenFatura.KayitTipi = 2;
              this.islemtipi = 1;
              this.guncellebuton = true;
              this.kaydetbuton = false;
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
              this.loadingdialog = false;
            }
            this.loadingdialog = false;
          },

          (response) => {
           this.text1 = $t('Error-Occured-Please-Try-Again')
            this.loadingdialog = false;
            this.snackbar = true;
          }
        );
      } else {
        this.snackbar = true;
        this.text1 = "Hatalı url";
        this.loadingdialog = false;

      }
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },
  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },

    orangoster: function (m) {
      return m * 100;
    },
  },
  methods: {
    changeSatisFatura(val) {
      this.GelenFatura.Fatura.SatisFaturasi.FatNo = val.FaturaNo;
      this.GelenFatura.Fatura.SatisFaturasi.FatSeri = val.SeriNo;
      this.GelenFatura.Fatura.SatisFaturasi.Id = val.GenelFatId;
      this.GelenFatura.Fatura.SatisFaturasi.FatTarih = val.Tarih;
      
      this.GelenFatura.Fatura.CariInfo.kod=val.CariKod;
      
      
      this.GelenFatura.Fatura.CariInfo.isim=val.CariAd;
      

      
      
    },
    openSatisFatDialog() {
      this.$refs.satisiadefatura.open();
    },

    toplammaliyetBul(secililist) {
      var sonuc = {
        maliyet: 0,
        kdvtutari: 0,
      };

      if (secililist.length != 0) {
        secililist.forEach((element) => {
          sonuc.maliyet = sonuc.maliyet + element.KalemMaliyet;
          sonuc.kdvtutari = sonuc.kdvtutari + element.KDVTutar;
        });
      } else {
      }
      return sonuc;
    },
    stopajtutarblur() {
      if (this.SatirGelenFatura.Tutar != 0) {
        this.SatirGelenFatura.StopajOran =
          (this.SatirGelenFatura.StopajTutar / this.SatirGelenFatura.Tutar) *
          100;
      } else {
        this.SatirGelenFatura.StopajOran = 0;
      }
    },
    kdvlitutarblur() {},
    tutarblur() {
      this.SatirGelenFatura.KDVTutar =
        (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.KDVYuzde;
      this.SatirGelenFatura.TevkifatTutar =
        this.SatirGelenFatura.KDVTutar * this.SatirGelenFatura.TevkifatOran;
      this.SatirGelenFatura.StopajTutar =
        (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.StopajOran;
    },
    kdvtutarblur() {},
    test2(v) {
      if (String(v).length > 3 && v != null) {
      }
    },

    sontutarkontrol(toplamdeger, toplam, deger) {
      toplam = this.roundNumber(toplam, 2);

      if (toplamdeger < toplam) {
        var fark = toplam - toplamdeger;
        var kdvtut = deger + fark;
        return kdvtut;
      } else if (toplamdeger > toplam) {
        var sonek = this.roundNumber(toplamdeger - deger, 2);
        var eklenecek = toplam - sonek;
        var kdvtut = eklenecek; // - fark
        return kdvtut;
      } else {
        return deger;
      }
    },

    twodigitcalc(bolunen, bolen) {
      var dizi = [];
      var a = parseFloat(bolunen);
      var b = parseFloat(bolen);

      if (a >= b) {
        var kactane = Math.floor(a / b);
        var ters = Math.floor(a / kactane);
      } else {
        var kactane = Math.floor(b / a);
        var ters = Math.floor(kactane / 1);
      }
      if (bolen != 0 && bolunen != 0) {
        var bolum = this.roundNumber(a / b, 2);
        var top = 0;
        var kalani = 0;
        for (var x = 0; x < b; x++) {
          kalani = a - top;
          if (x + 1 != b) {
            dizi.push(bolum);
          } else {
            dizi.push(this.roundNumber(kalani, 2));
          }
          top = top + bolum;
        }
        return dizi;
      } else {
        for (var x = 0; x < bolen; x++) {
          dizi.push(0);
        }
        return dizi;
      }
    },
    git(val) {
      var url =
        "#/fatura/copergelenfatura/id?islem=get&st=" +
        val.SaticiTip +
        "&sk=" +
        val.SaticiKod +
        "&fs=" +
        val.FatSeri +
        "&fn=" +
        val.FatNo +
        "&ft=" +
        val.FatTarih;
      window.open(url, "_self");
    },
    kalemguncellekaydet() {
      this.Kalem.KDVliTutar = this.Kalem.Tutar + this.Kalem.KDVTutar;

      var indexno = this.duzenlenenkayitindex;

      var kayit = {
        KDVYuzde: this.Kalem.KDVYuzde,
        Tutar: this.roundNumber(this.Kalem.Tutar, 2),
        KDVliTutar: this.roundNumber(this.Kalem.KDVliTutar, 2),
        KDVTutar: this.roundNumber(this.Kalem.KDVTutar, 2),
        PNR_No: Number(this.Kalem.PNR_No),
        TevkifatOran: this.Kalem.TevkifatOran,
        TevkifatTutar: this.roundNumber(this.Kalem.TevkifatTutar, 2),
        StopajOran: this.Kalem.StopajOran,
        StopajTutar: this.roundNumber(this.Kalem.StopajTutar, 2),
        IslemRef: this.Kalem.IslemRef,
        SaticiTip:this.Kalem.SaticiTip,
        SaticiKod:this.Kalem.SaticiKod,
      };

      this.GelenFatura.Fatura.Kalemler.splice(indexno, 1, kayit);
      this.kalemdialog = false;
      this.diptopla();
    },
    diptopla() {
      this.GelenFatura.Fatura.ToplamTutar = 0;
      this.GelenFatura.Fatura.ToplamKDVliTutar = 0;
      this.GelenFatura.Fatura.ToplamKDVTutar = 0;
      this.GelenFatura.Fatura.ToplamTevkifatTutar = 0;
      this.GelenFatura.Fatura.ToplamStopajTutar = 0;
      this.GelenFatura.Fatura.FaturaNetTutar = 0;

      this.GelenFatura.Fatura.Kalemler.forEach((element) => {
        this.GelenFatura.Fatura.ToplamTutar =
          this.GelenFatura.Fatura.ToplamTutar + element.Tutar;
        this.GelenFatura.Fatura.ToplamKDVliTutar =
          this.GelenFatura.Fatura.ToplamKDVliTutar + element.KDVliTutar;
        this.GelenFatura.Fatura.ToplamKDVTutar =
          this.GelenFatura.Fatura.ToplamKDVTutar + element.KDVTutar;
        this.GelenFatura.Fatura.ToplamTevkifatTutar =
          this.GelenFatura.Fatura.ToplamTevkifatTutar + element.TevkifatTutar;
        this.GelenFatura.Fatura.ToplamStopajTutar =
          this.GelenFatura.Fatura.ToplamStopajTutar + element.StopajTutar;
      });

      this.GelenFatura.Fatura.FaturaNetTutar =
        this.GelenFatura.Fatura.ToplamKDVliTutar -
        this.GelenFatura.Fatura.ToplamTevkifatTutar;
    },

    kalanVarmi(x, y) {
      var sonuc = {
        durum: false,
        bolum: 0,
        kalan: 0,
      };

      var c = this.roundNumber(x / y, 2);
      var carpim = c * y;
      var kalan = this.roundNumber(100 - carpim, 2);

      if (kalan != 0) {
        sonuc.durum = true;
        sonuc.kalan = kalan;
        sonuc.bolum = c;
      } else {
        sonuc.durum = false;
        sonuc.kalan = 0;
        sonuc.bolum = c;
      }
      return sonuc;
    },

    roundNumber(num, scale) {
      if (!("" + num).includes("e")) {
        return +(Math.round(num + "e+" + scale) + "e-" + scale);
      } else {
        var arr = ("" + num).split("e");
        var sig = "";
        if (+arr[1] + scale > 0) {
          sig = "+";
        }
        return +(
          Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) +
          "e-" +
          scale
        );
      }
    },

    esitOranla() {
      if (this.secilenkayitlar.length > 0) {
        if (this.SatirGelenFatura.Tutar > 0) {
          var toplamoran = 0;
          var secilenkayityedek = this.secilenkayitlar;
          this.secilenkayitlar = [];
          this.SatirGelenFatura.MatrahToplam = 0;
          this.SatirGelenFatura.KDVToplam = 0;
          this.SatirGelenFatura.TevkifatToplam = 0;
          this.SatirGelenFatura.TutarToplam = 0;
          var giris = true;
          var bolmesonuc = this.kalanVarmi(100, secilenkayityedek.length);
          var fiyatindex = 0;
          var tutarlarim = this.twodigitcalc(
            this.SatirGelenFatura.Tutar,
            secilenkayityedek.length
          );
          var kdvtutarlarim = this.twodigitcalc(
            this.SatirGelenFatura.KDVTutar,
            secilenkayityedek.length
          );
          var tevkifattutarlarim = this.twodigitcalc(
            this.SatirGelenFatura.TevkifatTutar,
            secilenkayityedek.length
          );
          var stopajtutarlarim = this.twodigitcalc(
            this.SatirGelenFatura.StopajTutar,
            secilenkayityedek.length
          );
          secilenkayityedek.forEach((element) => {
            var oran = 0;
            if (bolmesonuc.durum == true && giris == true) {
              giris = false;
            } else {
              oran = bolmesonuc.bolum / 100;
            }
            var indexno = this.itemsgelen.indexOf(element);
            var kayit = {
              PNR_No: element.PNR_No,
              SaticiTip: element.SaticiTip,
              SaticiKod: element.SaticiKod,
              SaticiAd: element.SaticiAd,
              TurOperatoru: element.TurOperatoru,
              Donem1: element.Donem1,
              Donem2: element.Donem2,
              KalemMaliyet: element.KalemMaliyet,
              KDVYuzde: this.SatirGelenFatura.KDVYuzde,
              Tutar: tutarlarim[fiyatindex],
              KDVTutar: kdvtutarlarim[fiyatindex],
              KDVliTutar: tutarlarim[fiyatindex] + kdvtutarlarim[fiyatindex],
              TevkifatTutar: tevkifattutarlarim[fiyatindex],
              TevkifatOran: this.SatirGelenFatura.TevkifatOran,
              StopajTutar: stopajtutarlarim[fiyatindex],
              StopajOran: this.SatirGelenFatura.StopajOran,
              IslemRef: element.IslemRef,
            };
            this.SatirGelenFatura.MatrahToplam =
              this.SatirGelenFatura.MatrahToplam + kayit.Tutar;
            this.SatirGelenFatura.KDVToplam =
              this.SatirGelenFatura.KDVToplam + kayit.KDVTutar;
            this.SatirGelenFatura.TevkifatToplam =
              this.SatirGelenFatura.TevkifatToplam + kayit.TevkifatTutar;
            this.SatirGelenFatura.TutarToplam =
              this.SatirGelenFatura.TutarToplam +
              kayit.Tutar -
              kayit.TevkifatTutar;

            this.itemsgelen.splice(indexno, 1, kayit);
            this.secilenkayitlar.push(kayit);
            fiyatindex++;
          });
        } else {
          this.text1 = this.$t('Your-amount-must-be-greater-than-zero');
          this.snackbar = true;
          this.loadingdialog = false;
        }
      } else {
        this.text1 = this.$t('Please-select-items')
        this.snackbar = true;
        this.loadingdialog = false;
      }
    },

    maliyetegoreOranla() {
      if (this.secilenkayitlar.length > 0) {
        if (this.SatirGelenFatura.Tutar > 0) {
          this.SatirGelenFatura.MatrahToplam = 0;
          this.SatirGelenFatura.KDVToplam = 0;
          this.SatirGelenFatura.TevkifatToplam = 0;
          var toplammaliyet = 0;
          this.secilenkayitlar.forEach((element) => {
            toplammaliyet = toplammaliyet + element.KalemMaliyet;
          });

          var secilenkayityedek = this.secilenkayitlar;
          this.secilenkayitlar = [];
          this.SatirGelenFatura.MatrahToplam = 0;
          this.SatirGelenFatura.KDVToplam = 0;
          this.SatirGelenFatura.TevkifatToplam = 0;
          this.SatirGelenFatura.TutarToplam = 0;
          var toplamoran = 0;
          var x = 0;
          var toplamkdv = 0;
          var toplamtutar = 0;
          var toplamtevkifat = 0;
          var toplamstopaj = 0;

          secilenkayityedek.forEach((element) => {
            var oran = 0;
            var kdvtut = 0;
            var tutar = 0;
            var tevkifattutar = 0;
            var stopajtutar = 0;
            if (element.KalemMaliyet != 0) {
              oran = this.roundNumber(element.KalemMaliyet / toplammaliyet, 2);
              kdvtut = this.SatirGelenFatura.KDVTutar * oran;
              tutar = this.SatirGelenFatura.Tutar * oran;
              tevkifattutar = this.SatirGelenFatura.TevkifatTutar * oran;
              stopajtutar = this.SatirGelenFatura.StopajTutar * oran;
            }

            toplamkdv = toplamkdv + this.roundNumber(kdvtut, 2);
            toplamtutar = toplamtutar + this.roundNumber(tutar, 2);
            toplamtevkifat =
              toplamtevkifat + this.roundNumber(tevkifattutar, 2);
            toplamstopaj = toplamstopaj + this.roundNumber(stopajtutar, 2);

            if (x == secilenkayityedek.length - 1) {
              kdvtut = this.sontutarkontrol(
                toplamkdv,
                this.SatirGelenFatura.KDVTutar,
                this.SatirGelenFatura.KDVTutar * oran
              );

              tutar = this.sontutarkontrol(
                toplamtutar,
                this.SatirGelenFatura.Tutar,
                this.SatirGelenFatura.Tutar * oran
              );

              tevkifattutar = this.sontutarkontrol(
                toplamtevkifat,
                this.SatirGelenFatura.TevkifatTutar,
                this.SatirGelenFatura.TevkifatTutar * oran
              );

              stopajtutar = this.sontutarkontrol(
                toplamstopaj,
                this.SatirGelenFatura.StopajTutar,
                this.SatirGelenFatura.StopajTutar * oran
              );
            }
            toplamoran = toplamoran + oran;
            var indexno = this.itemsgelen.indexOf(element);
            var kayit = {
              PNR_No: element.PNR_No,
              SaticiTip: element.SaticiTip,
              SaticiKod: element.SaticiKod,
              SaticiAd: element.SaticiAd,
              TurOperatoru: element.TurOperatoru,
              Donem1: element.Donem1,
              Donem2: element.Donem2,
              KalemMaliyet: element.KalemMaliyet,
              KDVYuzde: this.SatirGelenFatura.KDVYuzde,
              Tutar: this.roundNumber(tutar, 2),
              KDVTutar: this.roundNumber(kdvtut, 2),
              KDVliTutar:
                this.roundNumber(tutar, 2) + this.roundNumber(kdvtut, 2),
              TevkifatTutar: this.roundNumber(tevkifattutar, 2),
              TevkifatOran: this.SatirGelenFatura.TevkifatOran,
              StopajTutar: this.roundNumber(stopajtutar, 2),
              StopajOran: this.SatirGelenFatura.StopajOran,
              IslemRef: element.IslemRef,
            };

            this.SatirGelenFatura.MatrahToplam =
              this.SatirGelenFatura.MatrahToplam + kayit.Tutar;
            this.SatirGelenFatura.KDVToplam =
              this.SatirGelenFatura.KDVToplam + kayit.KDVTutar;
            this.SatirGelenFatura.TevkifatToplam =
              this.SatirGelenFatura.TevkifatToplam + kayit.TevkifatTutar;
            this.SatirGelenFatura.TutarToplam =
              this.SatirGelenFatura.TutarToplam +
              kayit.Tutar -
              kayit.TevkifatTutar;

            this.secilenkayitlar.push(kayit);

            this.itemsgelen.splice(indexno, 1, kayit);
            x = x + 1;
          });
        } else {
          this.text1 = this.$t('Your-amount-must-be-greater-than-zero');
          this.snackbar = true;
          this.loadingdialog = false;
        }
      } else {
        this.text1 = this.$t('Please-select-items')
        this.snackbar = true;
        this.loadingdialog = false;
      }
    },
    kalemGetir() {
      this.secilenkayitlar = [];
      this.itemsgelen = [];
      this.pnrkalemloading = true;

      var yeniliste = [];

      let params = {
        GenelFaturaId: this.GelenFatura.Fatura.SatisFaturasi.Id,
      };

      tool.http_post(this, "SatisIadeFaturaPNRKalemList", params).then(
        (response) => {
          if (response.body.Status == true) {
            var maliyet = 0;
            var kdvtutari = 0;

            this.SatirGelenFatura.KDVYuzde = response.body.data[0].KDV;

            response.body.data.forEach((element) => {
              var kayit = {
                PNR_No: element.PNR_No,
                SaticiTip: element.SaticiTip,
                SaticiKod: element.SaticiKod,
                SaticiAd: element.SaticiAd,
                //TurOperatoru: element.TurOperatoru.kod,
                Donem1: element.Donem1,
                Donem2: element.Donem2,
                KalemMaliyet: element.Tutar + element.KDV_Tutar,
                KDVYuzde: element.KDV,
                Tutar: element.Tutar,
                KDVTutar: element.KDV_Tutar,
                KDVliTutar: element.Tutar + element.KDV_Tutar,
                TevkifatTutar: 0,
                TevkifatOran: 0,
                StopajTutar: 0,
                StopajOran: 0,
                IslemRef: element.IslemRef,
              };

              yeniliste.push(kayit);
            });

            this.itemsgelen = yeniliste;

            if (response.body.data.length > 0) {
              this.kalemkayitvarmi = true;
            } else {
              this.kalemkayitvarmi = false;
            }

            this.pnrkalemloading = false;

            //if (this.pnrtip == false)
            {
              this.secilenkayitlar = this.itemsgelen;
              var sonuc = this.toplammaliyetBul(this.secilenkayitlar);
              this.SatirGelenFatura.Tutar =
                sonuc.maliyet / (this.SatirGelenFatura.KDVYuzde / 100 + 1);
              this.SatirGelenFatura.KDVTutar =
                (this.SatirGelenFatura.Tutar / 100) *
                this.SatirGelenFatura.KDVYuzde;
            }
            /*
              else {
                this.secilenkayitlar = [];
                this.itemsgelen.forEach((element) => {
                  if (element.SaticiKod == this.GelenFatura.Fatura.Satici.kod) {
                    this.secilenkayitlar.push(element);
                  }
                });

                var sonuc = this.toplammaliyetBul(this.secilenkayitlar);
                this.SatirGelenFatura.Tutar =
                  sonuc.maliyet / (this.SatirGelenFatura.KDVYuzde / 100 + 1);
                this.SatirGelenFatura.KDVTutar =
                  (this.SatirGelenFatura.Tutar / 100) *
                  this.SatirGelenFatura.KDVYuzde;
              }
              */

            this.satirdialog = true;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
            this.pnrkalemloading = false;
            this.kalemkayitvarmi = false;
            this.loadingdialog = false;
          }
        },

        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.pnrkalemloading = false;
          this.kalemkayitvarmi = false;
          this.loadingdialog = false;
        }
      );
    },
    getparabirimiDefault(val) {
      return helpers.getparabirimiDefault(val);
    },
    getparabirimi() {
      return helpers.getparabirimi();
    },
    faturatoplambul() {
      this.SerbestFatura.Tutarlar.FaturaToplam = 0;
      this.satiritems.forEach((element) => {
        if (element.KdvTip == "H") {
          this.SerbestFatura.Tutarlar.FaturaToplam =
            this.SerbestFatura.Tutarlar.FaturaToplam +
            element.Tutar +
            element.KdvTutar -
            this.SerbestFatura.Tutarlar.Iskonto -
            this.SerbestFatura.Tutarlar.TevkifatKdv;
        } else {
          this.SerbestFatura.Tutarlar.FaturaToplam =
            this.SerbestFatura.Tutarlar.FaturaToplam +
            element.Tutar -
            this.SerbestFatura.Tutarlar.Iskonto -
            this.SerbestFatura.Tutarlar.TevkifatKdv;
        }
      });
    },

    faturanotarihdegistir(tur) {
      this.dialogdegistir = true;
      if (tur == 0) {
        this.islemturu = 0;
        this.ChangeFaturaNo = this.SerbestFatura.FaturaNo;
        this.ChangeTarih = null;
      } else if (tur == 1) {
        this.ChangeTarih = this.SerbestFatura.Tarih;
        this.ChangeFaturaNo = null;
        this.islemturu = 1;
      }
    },

    satirguncellekaydet() {
      const index = this.secilensatirno;

      var degisenkayit = {};

      var yedeksatiritems = [];

      yedeksatiritems = this.satiritems;

      this.satiritems = [];

      this.SerbestFatura.Tutarlar.ToplamTutar =
        this.SerbestFatura.Tutarlar.ToplamTutar - this.yedeksatirkayit.Tutar;
      this.SerbestFatura.Tutarlar.Kdv =
        this.SerbestFatura.Tutarlar.Kdv - this.yedeksatirkayit.Kdv;
      this.SerbestFatura.Tutarlar.TevkifatKdv =
        this.SerbestFatura.Tutarlar.TevkifatKdv - this.yedeksatirkayit.Tevkifat;
      this.SerbestFatura.Tutarlar.Iskonto =
        this.SerbestFatura.Tutarlar.Iskonto - this.yedeksatirkayit.iskonto;

      if (this.SerbestFaturaDetay.DovizTutar > 0) {
        var n = this.SerbestFaturaDetay.DovizTutar;
      }

      var satiryeni = {
        MuhasebeKodu: this.SerbestFaturaDetay.MuhasebeKodu,
        Aciklama: this.SerbestFaturaDetay.Aciklama,
        Referans: {
          Kod: this.SerbestFaturaDetay.Referans.Kod,
        },
        Masraf: {
          Code: this.SerbestFaturaDetay.Masraf.Code,
        },
        Miktar: this.SerbestFaturaDetay.Miktar,
        LineNote: this.SerbestFaturaDetay.LineNote,

        BirimFiyat: this.SerbestFaturaDetay.BirimFiyat,
        Tutar: this.SerbestFaturaDetay.Tutar,
        TevkifatDetayTutar: this.SerbestFaturaDetay.TevkifatDetayTutar,
        DovizTutar: this.SerbestFaturaDetay.DovizTutar,
        TevkifatDetayOran: this.SerbestFaturaDetay.TevkifatDetayOran,
        IskontoYuzde: this.SerbestFaturaDetay.IskontoYuzde,
        IskontoTutar: this.SerbestFaturaDetay.IskontoTutar,
        KdvKodu: this.SerbestFaturaDetay.KdvKodu,
        KdvMuhKodu: this.SerbestFaturaDetay.KdvMuhKodu, //
        IskMuhKodu: this.SerbestFaturaDetay.IskMuhKodu, //
        KdvTutar: this.SerbestFaturaDetay.KdvTutar,
        KdvTip: this.SerbestFaturaDetay.KdvTip,
        KdvYuzde: this.SerbestFaturaDetay.KdvYuzde,
        IstisnaKodu: this.SerbestFaturaDetay.IstisnaKodu,
        TevkifatKodu: this.SerbestFaturaDetay.TevkifatKodu,
        Tip: this.SerbestFaturaDetay.Tip,
      };

      for (var i = 0; i < yedeksatiritems.length; i++) {
        if (index == i) {
          this.satiritems.push(satiryeni);
        } else {
          this.satiritems.push(yedeksatiritems[i]);
        }
      }

      this.satirdialog = false;
      this.SerbestFatura.Tutarlar.ToplamTutar =
        this.SerbestFatura.Tutarlar.ToplamTutar + satiryeni.Tutar;
      this.SerbestFatura.Tutarlar.Kdv =
        this.SerbestFatura.Tutarlar.Kdv + satiryeni.KdvTutar;
      this.SerbestFatura.Tutarlar.TevkifatKdv =
        this.SerbestFatura.Tutarlar.TevkifatKdv + satiryeni.TevkifatDetayTutar;
      this.SerbestFatura.Tutarlar.Iskonto =
        this.SerbestFatura.Tutarlar.Iskonto + satiryeni.IskontoTutar;
      this.faturatoplambul();
    },

    satirsilsor(item) {
      this.dialogsor = true;
      this.faturasilbtn = false;
      (this.satirsilbtn = true), (this.silinecekkayit = item);
    },
    faturasilsor() {
      this.dialogsor = true;
      this.faturasilbtn = true;
      this.satirsilbtn = false;
    },
    satirsil(a) {
      this.$refs.onaydialog
        .open(this.$t('Are-you-sure-you-want-to-delete-this-record'), 1)
        .then((sonuc) => {
          if (sonuc == true) {
            const index = this.GelenFatura.Fatura.Kalemler.indexOf(a);
            if (index != -1) {
              this.GelenFatura.Fatura.Kalemler.splice(index, 1);
              this.dialogsor = false;
              this.diptopla();
            }
          }
        });
    },
    satirduzenle(a) {
      var kayit = {
        KDVYuzde: a.KDVYuzde,
        Tutar: a.Tutar,
        KDVliTutar: a.KDVliTutar,
        KDVTutar: a.KDVTutar,
        PNR_No: a.PNR_No,
        TevkifatOran: a.TevkifatOran,
        TevkifatTutar: a.TevkifatTutar,
        StopajOran: a.StopajOran,
        StopajTutar: a.StopajTutar,
        IslemRef: a.IslemRef,
        SaticiTip: a.SaticiTip,
        SaticiKod : a.SaticiKod,
      };

      this.Kalem = kayit;

      this.duzenlenenkayitindex = this.GelenFatura.Fatura.Kalemler.indexOf(a);
      this.kalemdialog = true;
    },
    tarihkontrol(v) {
      if (v != "0001-01-01T00:00:00" && v != null) {
        var parts1 = v.split("-");
        return parts1[2] + "-" + parts1[1] + "-" + parts1[0];
      } else {
        return null;
      }
    },

    satirekle: satirekle,

    getDateNow: getDateNow,
    getDateNow1: getDateNow1,
    toDateformat: toDateformat,

    Kaydet: Kaydet,
    satirkaydet: satirkaydet,

    Tevkifatkdvhesapla: Tevkifatkdvhesapla,

    kurgetir: kurgetir,
    kurgetir2: kurgetir2,

    faturasil: faturasil,
  },

  components: {
    parainputevents: parainputevents,
    dovizinput: dovizinput,
    yuzdeinput: yuzdeinput,
    tarihcomp: tarihcomp,
    referansmerkezicomp,
    masrafmerkezicomp,
    geneltiplist,
    yetkidialog,
    onaydialog,
    genelarama,
    pnrbul,
    geneltipara,
    muhasebefistipara,
    caricomp,
    satisiadefatura,
  },
  watch: {
    secilenkayitlar: function (val) {
      var sonuc = this.toplammaliyetBul(val);

      this.SatirGelenFatura.Tutar =
        sonuc.maliyet / (this.SatirGelenFatura.KDVYuzde / 100 + 1);

      this.SatirGelenFatura.KDVTutar =
        (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.KDVYuzde;

      this.SatirGelenFatura.TevkifatTutar =
        this.SatirGelenFatura.KDVTutar * this.SatirGelenFatura.TevkifatOran;

      this.SatirGelenFatura.StopajTutar =
        (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.StopajOran;
    },
    "GelenFatura.Fatura.Satici.CariKod": function (val) {},

    "SatirGelenFatura.KDVYuzde": function (val) {
      var sonuc = this.toplammaliyetBul(this.secilenkayitlar);

      this.SatirGelenFatura.Tutar = sonuc.maliyet / (val / 100 + 1);

      this.SatirGelenFatura.KDVTutar =
        (this.SatirGelenFatura.Tutar / 100) * val;

      this.SatirGelenFatura.TevkifatTutar =
        this.SatirGelenFatura.KDVTutar * this.SatirGelenFatura.TevkifatOran;

      this.SatirGelenFatura.StopajTutar =
        (this.SatirGelenFatura.Tutar / 100) * this.SatirGelenFatura.StopajOran;

      //   this.SatirGelenFatura.TevkifatTutar = this.SatirGelenFatura.KDVTutar * this.SatirGelenFatura.TevkifatOran
    },
    "SatirGelenFatura.TevkifatOran": function (val) {
      if (val > 0 && this.SatirGelenFatura.KDVTutar > 0) {
        this.SatirGelenFatura.TevkifatTutar =
          this.SatirGelenFatura.KDVTutar * val;
      } else {
        this.SatirGelenFatura.TevkifatTutar = 0;
      }
    },
    "SatirGelenFatura.StopajOran": function (val) {
      if (val > 0 && this.SatirGelenFatura.Tutar > 0) {
        this.SatirGelenFatura.StopajTutar =
          (this.SatirGelenFatura.Tutar / 100) * val;
      } else {
        this.SatirGelenFatura.StopajTutar = 0;
      }
    },
    "SatirGelenFatura.Tutar": function (val) {},

    "Kalem.KDVYuzde": function (val) {
      if (val > 0) {
        this.Kalem.KDVTutar = (this.Kalem.Tutar / 100) * val;
      }
    },
    "Kalem.TevkifatOran": function (val) {
      if (val > 0 && this.Kalem.KDVTutar > 0) {
        this.Kalem.TevkifatTutar = this.Kalem.KDVTutar * val;
      } else {
        this.Kalem.TevkifatTutar = 0;
      }
    },
    "Kalem.StopajOran": function (val) {
      if (val > 0 && this.Kalem.Tutar > 0) {
        this.Kalem.StopajTutar = (this.Kalem.Tutar / 100) * val;
      } else {
        this.Kalem.StopajTutar = 0;
      }
    },
    "SerbestFatura.FaturaTip": function (val) {
      if (val == 1) {
        this.$refs.onaydialog
          .open(
            this.$t('Details-regarding-return-invoice-will-entered-after-save-update-process'),
            2
          )
          .then((sonuc) => {
            if (sonuc == true) {
            }
          });
      }
    },

    "GelenFatura.Fatura.SatisPara": function (dovizkod) {
      if (dovizkod != null && this.islemtipi == 1) {
      }
    },
    "GelenFatura.Fatura.FatPara": function (dovizkod) {
      if (dovizkod != null && this.islemtipi == 1) {
        //     this.kurgetir2();
      }
    },
  },
};

function kurgetir() {
  // Bos doviz kodunda kur sorulmaz; sunucu "Doviz Kodu Bos olamaz" diye 500 donuyordu.
  var dovizKod = this.GelenFatura.Fatura.SatisPara;
  if (dovizKod == null || dovizKod == '') {
    return;
  }

  var params1 = {
    Tarih: this.GelenFatura.Fatura.FatTarih,
    DovizKod: this.GelenFatura.Fatura.SatisPara,
  };
      
  this.$http
    .post(auth.API_URL + "api/Definitions/GetWebRate", params1, {
      headers: auth.getAuthCompaniesInfo()
    })
    .then(
      (response) => {
          if(response.body == 0.0){
           this.GelenFatura.Fatura.SatisKur = 1
          }else{
           this.GelenFatura.Fatura.SatisKur = response.body
          }
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable-GetWebRate";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable-GetWebRate";
          this.snackbar = true;
        }
      }
    );
}

function kurgetir2() {
  // Bos doviz kodunda kur sorulmaz; sunucu "Doviz Kodu Bos olamaz" diye 500 donuyordu.
  var dovizKod = this.GelenFatura.Fatura.FatPara;
  if (dovizKod == null || dovizKod == '') {
    return;
  }

  var params1 = {
    Tarih: this.GelenFatura.Fatura.FatTarih,
    DovizKod: this.GelenFatura.Fatura.FatPara,
  };

  this.$http
    .post(auth.API_URL + "api/Definitions/GetWebRate", params1, {
      headers: auth.getAuthCompaniesInfo()
    })
    .then(
      (response) => {
          if(response.body == 0.0){
           this.GelenFatura.Fatura.FatKur = 1
          }else{
           this.GelenFatura.Fatura.FatKur = response.body
          }
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable-GetWebRate";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable-GetWebRate";
          this.snackbar = true;
        }
      }
    );
}

function Tevkifatkdvhesapla() {
  var params1 = {
    TevkifatOran: this.SerbestFaturaDetay.TevkifatDetayOran,
    KdvTutar: this.SerbestFaturaDetay.KdvTutar,
  };

  this.$http
    .post(auth.API_URL + "api/Helpers/GetWithHoldingAmount", params1, {
      headers: {
        Authorization: "Bearer " + auth.getAuthHeader(),
      },
    })
    .then(
      (response) => {
        this.SerbestFaturaDetay.TevkifatDetayTutar =
          response.body.TevkifatTutar;
      },
      (response) => {
        if (response.status === 0) {
          this.text1 = "Service Unavailable-Iskonto Hesapla";
          this.snackbar = true;
        } else {
          this.text1 = "Service Unavailable-Iskonto Hesapla";
          this.snackbar = true;
        }
      }
    );
}

function satirekle() {
  //this.satirdialog = true;
  this.secilenkayitlar = [];
  this.pnretiket = this.$t('Select-pnr-belonging-seller');

  this.itemsgelen = [];
  this.SatirGelenFatura.PnrNo = null;
  this.SatirGelenFatura.KDVYuzde = 0;
  this.SatirGelenFatura.Tutar = 0;
  this.SatirGelenFatura.KDVTutar = 0;
  this.SatirGelenFatura.KDVliTutar = 0;
  this.SatirGelenFatura.TevkifatTutar = 0;
  this.SatirGelenFatura.TevkifatOran = 0;
  this.SatirGelenFatura.StopajTutar = 0;
  this.SatirGelenFatura.StopajOran = 0;
  this.SatirGelenFatura.MatrahToplam = 0;
  this.SatirGelenFatura.TutarToplam = 0;
  this.SatirGelenFatura.KDVToplam = 0;
  this.SatirGelenFatura.TevkifatToplam = 0;

  this.kalemGetir();
}

function satirkaydet() {
  var durum = false;
  this.secilenkayitlar.forEach((element) => {
    if (element.KalemMaliyet == 0) {
      durum = true;
    }
  });

  if (durum == false) {
    this.maliyetegoreOranla();
  } else {
    this.esitOranla();
  }

  this.secilenkayitlar.forEach((element) => {
    var kayit = {
      KDVYuzde: element.KDVYuzde,
      Tutar: element.Tutar,
      KDVliTutar: this.roundNumber(element.KDVliTutar, 2),
      KDVTutar: this.roundNumber(element.KDVTutar, 2),
      PNR_No: Number(element.PNR_No),
      TevkifatOran: element.TevkifatOran,
      TevkifatTutar: this.roundNumber(element.TevkifatTutar, 2),
      StopajOran: element.StopajOran,
      StopajTutar: this.roundNumber(element.StopajTutar, 2),
      IslemRef: element.IslemRef,
      SaticiTip: element.SaticiTip,
      SaticiKod:element.SaticiKod,
    };
    this.GelenFatura.Fatura.Kalemler.push(kayit);
  });

  this.satirdialog = false;
  this.diptopla();
}

//kaydetme işlemi
function Kaydet(tip) {
  if (this.$refs.formgelenfatura.validate()) {
    if (this.GelenFatura.Fatura.Kalemler.length > 0) {
      this.loadingdialog = true;
      this.GelenFatura.KayitTipi = tip;
      //this.GelenFatura.Fatura.SaticiKod = this.GelenFatura.Fatura.Satici.kod;

      let params = this.GelenFatura;
      tool.http_post(this, "SatisIadeFaturaKaydet", params).then(
        (response) => {
          this.loadingdialog = false;

          if (response.body.Status == true) {
            this.text1 = "Kayıt işlemi tamamlandı";
            this.snackbar = true;

            //this.git(response.body.data);
            this.GelenFatura.Fatura = response.body.data;

            if (tip == "1") {
              this.GelenFatura.EskiFatura.FatSeri = response.body.data.FatSeri;
              this.GelenFatura.EskiFatura.FatNo = response.body.data.FatNo;
              this.GelenFatura.EskiFatura.FatTarih = response.body.data.FatTarih;
              this.GelenFatura.EskiFatura.CariKod =  response.body.data.CariInfo.kod;
            }

            this.GelenFatura.KayitTipi = 2;
            this.islemtipi = 1;
            this.guncellebuton = true;
            this.kaydetbuton = false;
          } else {
            this.text1 = response.body.ErrorList[0];
            this.snackbar = true;
          }
        },

        (response) => {
         this.text1 = $t('Error-Occured-Please-Try-Again')
          this.snackbar = true;
          this.loadingdialog = false;
        }
      );
    } else {
      this.text1 = this.$t('Please-add-items');
      this.snackbar = true;
      this.loadingdialog = false;
    }
  } else {
    this.text1 = this.$t('Please-fill-required-fields');
    this.snackbar = true;
    this.loadingdialog = false;
  }
}

function faturasil() {
  this.$refs.onaydialog
    .open("Bu faturayı silmek istediğinize emin misiniz?", 1)
    .then((sonuc) => {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      if (sonuc == true) {
        let params = {
          CariKod: this.GelenFatura.EskiFatura.CariKod,
          FatSeri: this.GelenFatura.EskiFatura.FatSeri,
          FatNo: this.GelenFatura.EskiFatura.FatNo,
          FatTarih: this.GelenFatura.EskiFatura.FatTarih,
        };

        tool.http_post(this, "SatisIadeFaturaSil", params).then(
          (response) => {
            if (response.body.Status == true) {
              this.text1 = "Faturanız silindi.";
              this.snackbar = true;

              var url = "#/fatura/copersatisiade";
              setTimeout(
                function () {
                  window.open(url, "_self");
                }.bind(this),
                6000
              );
            } else {
              this.text1 = response.body.ErrorList[0];
              this.snackbar = true;
            }
          },

          (response) => {
           this.text1 = $t('Error-Occured-Please-Try-Again')
            this.loadingdialog = false;
            this.snackbar = true;
          }
        );
      }
    });
}

function getDateNow() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }

  if (mm < 10) {
    mm = "0" + mm;
  }
  today = yyyy + "-" + mm + "-" + dd;
  return today;
}

function getDateNow1() {
  var today = new Date();
  var dd = today.getDate();
  var mm = today.getMonth() + 1; //January is 0!
  var yyyy = today.getFullYear();

  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  today = dd + "." + mm + "." + yyyy;
  return today;
}

function toDateformat(dateStr) {
  var parts = dateStr.split("-");
  return parts[2] + "." + parts[1] + "." + parts[0];
}
</script>

<style>
.outer {
  position: relative;
  display: inline-block;
  margin: 0 10px;
  padding-top: inherit + 100px;
}

.inner {
  position: absolute;
  top: 104%;
  left: 50%;
  padding-block-start: 30px;
  padding-block-end: 10px;
}

.icorta {
  margin: 0px auto;
  height: 226px;
  color: #fff;
  position: absolute;
  left: 92%;
  top: 95%;
  margin-left: -110px;
  margin-top: -15px;
}

.rotate {
  -moz-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(-90deg);
  transform: translateX(-50%) translateY(-50%) rotate(-90deg);
}
</style>